import React, { FC } from "react";
import { getImageUrl } from "src/utils/getImageUrl";
import { IBlogSection } from "src/@types/blog";
import Fancybox from "src/components/Fancybox";
import "./section.scss";

interface Props {
  sections: IBlogSection[];
}

export const SectionsList: FC<Props> = ({ sections }) => {
  return (
    <>
      {sections.map(({ id, title, slug, image, body }) => (
        <article key={id} className="flex flex-col gap-7">
          <h3
            id={slug}
            className="text-purple-base text-2xl font-semibold pt-20 -mt-20 -z-10"
          >
            {title}
          </h3>

          {image && (
            <Fancybox className="w-full h-60">
              <a data-fancybox="gallery" href={getImageUrl(image)}>
                <img
                  className="w-full h-full object-cover object-center rounded-lg"
                  src={getImageUrl(image)}
                  alt={title}
                />
              </a>
            </Fancybox>
          )}

          <div
            className="break-words rich-text"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </article>
      ))}
    </>
  );
};
